import { Link } from "@/lib/router-compat";
import Navbar from "@/components/Navbar";

/**
 * Intentional not-found page for unmatched in-app routes. Direct HTTP
 * requests to unknown paths are converted to a real 404 with
 * X-Robots-Tag: noindex, nofollow by the server (src/server.ts), so this
 * component only renders for soft client-side navigation to a bad route.
 */
const NotFound = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col font-body">
      <Navbar forceSolid />
      <div className="flex-1 flex items-center justify-center px-5 py-32 text-center">
        <div className="max-w-md">
          <span className="block text-[#ffcc29] font-heading font-bold tracking-[0.25em] uppercase text-sm mb-4">
            404 — Not Found
          </span>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#002b5c] mb-4">
            Page Not Found
          </h1>
          <p className="text-xl text-foreground/70 mb-8">
            The page you are looking for does not exist or may have been moved.
            Please use the links below to find what you need.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-[#002b5c] text-white px-6 py-3 rounded-xs font-heading font-bold text-xs uppercase tracking-wider hover:bg-[#ffcc29] hover:text-[#002b5c] transition-all"
            >
              Return to Home
            </Link>
            <Link
              to="/services"
              className="inline-flex items-center gap-2 border border-[#002b5c] text-[#002b5c] px-6 py-3 rounded-xs font-heading font-bold text-xs uppercase tracking-wider hover:bg-[#002b5c] hover:text-white transition-all"
            >
              Our Services
            </Link>
            <Link
              to="/projects"
              className="inline-flex items-center gap-2 border border-[#002b5c] text-[#002b5c] px-6 py-3 rounded-xs font-heading font-bold text-xs uppercase tracking-wider hover:bg-[#002b5c] hover:text-white transition-all"
            >
              Our Projects
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 border border-[#002b5c] text-[#002b5c] px-6 py-3 rounded-xs font-heading font-bold text-xs uppercase tracking-wider hover:bg-[#002b5c] hover:text-white transition-all"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
